// タブ切り替え式統計表示のAlpine.jsコンポーネント
document.addEventListener('alpine:init', () => {
  const loadingTemplate = `
    <div class="flex flex-col justify-center items-center py-8 space-y-3">
      <svg class="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <div class="text-gray-500 text-sm">統計を計算中<span class="loading-dots"></span></div>
    </div>
  `

  const errorTemplate = '<div class="text-red-500 py-8 text-center">統計の読み込みに失敗しました</div>'

  Alpine.data('statsTabs', (successUrl, failureUrl) => ({
    activeTab: 'success',
    successContent: loadingTemplate,
    failureContent: loadingTemplate,
    successLoaded: false,
    failureLoaded: false,

    init() {
      // 初期表示時に成功統計を読み込む
      this.loadSuccessStats()
    },

    async switchTab(tab) {
      this.activeTab = tab
      if (tab === 'success' && !this.successLoaded) {
        await this.loadSuccessStats()
      } else if (tab === 'failure' && !this.failureLoaded) {
        await this.loadFailureStats()
      }
    },

    async loadSuccessStats() {
      console.log('[StatsTabs] Loading success stats from:', successUrl)

      try {
        const response = await fetch(successUrl, {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })

        console.log('[StatsTabs] Success stats response status:', response.status)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const html = await response.text()
        console.log('[StatsTabs] Success stats HTML length:', html.length)

        this.successContent = html
        this.successLoaded = true
        console.log('[StatsTabs] Success stats content updated')
      } catch (error) {
        console.error('[StatsTabs] Success stats error:', error)
        this.successContent = errorTemplate
      }
    },

    async loadFailureStats() {
      console.log('[StatsTabs] Loading failure stats from:', failureUrl)

      try {
        const response = await fetch(failureUrl, {
          headers: {
            'Accept': 'text/html',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })

        console.log('[StatsTabs] Failure stats response status:', response.status)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const html = await response.text()
        console.log('[StatsTabs] Failure stats HTML length:', html.length)

        this.failureContent = html
        this.failureLoaded = true
        console.log('[StatsTabs] Failure stats content updated')
      } catch (error) {
        console.error('[StatsTabs] Failure stats error:', error)
        this.failureContent = errorTemplate
      }
    }
  }))
})
